import React from 'react';

import { SVGComponentProps } from './svg.types';

const LinkSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps): JSX.Element => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 14 14"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M7.0229 10.3679L6.1029 11.2879C5.64623 11.6997 5.04897 11.9204 4.4343 11.9047C3.81964 11.8889 3.23446 11.6378 2.79949 11.2033C2.36452 10.7687 2.11294 10.1837 2.09664 9.56907C2.08034 8.95442 2.30057 8.35696 2.7119 7.89993L3.6319 6.97993C3.82073 6.79136 3.92692 6.5355 3.92711 6.26864C3.9273 6.00178 3.82147 5.74577 3.6329 5.55693C3.44433 5.3681 3.18847 5.26191 2.9216 5.26172C2.65474 5.26153 2.39873 5.36736 2.2099 5.55593L1.2909 6.47593C0.464349 7.30248 0 8.42352 0 9.59243C0 10.7613 0.464349 11.8824 1.2909 12.7089C2.11744 13.5355 3.23848 13.9998 4.4074 13.9998C5.57631 13.9998 6.69735 13.5355 7.5239 12.7089L8.4439 11.7899C8.63247 11.6015 8.73846 11.3459 8.73855 11.0793C8.73864 10.8127 8.63283 10.557 8.4444 10.3684C8.25596 10.1799 8.00033 10.0739 7.73375 10.0738C7.46717 10.0737 7.21147 10.1795 7.0229 10.3679Z"
          fill={fill}
        />
        <path
          d="M7.71103 4.86852L4.86803 7.71152C4.67959 7.89995 4.57373 8.15553 4.57373 8.42202C4.57373 8.68851 4.67959 8.94408 4.86803 9.13252C5.05647 9.32095 5.31204 9.42682 5.57853 9.42682C5.84502 9.42682 6.10059 9.32095 6.28903 9.13252L9.13203 6.28952C9.32047 6.10108 9.42633 5.84551 9.42633 5.57902C9.42633 5.31253 9.32047 5.05695 9.13203 4.86852C8.94359 4.68008 8.68802 4.57422 8.42153 4.57422C8.15504 4.57422 7.89947 4.68008 7.71103 4.86852Z"
          fill={fill}
        />
        <path
          d="M12.7089 1.29106C12.2996 0.881749 11.8138 0.557061 11.2791 0.335539C10.7443 0.114017 10.1712 0 9.59238 0C9.01358 0 8.44045 0.114017 7.90571 0.335539C7.37098 0.557061 6.88512 0.881749 6.47588 1.29106L5.55588 2.21006C5.36731 2.3985 5.26132 2.65412 5.26123 2.92071C5.26114 3.18729 5.36695 3.44299 5.55538 3.63156C5.74382 3.82013 5.99945 3.92612 6.26603 3.92621C6.53261 3.92631 6.78831 3.8205 6.97688 3.63206L7.89688 2.71206C8.35354 2.30033 8.95081 2.07957 9.56548 2.09533C10.1801 2.11108 10.7653 2.36215 11.2003 2.79673C11.6353 3.23132 11.8868 3.81627 11.9031 4.43092C11.9194 5.04557 11.6992 5.64303 11.2879 6.10006L10.3679 7.02006C10.179 7.20863 10.0729 7.46449 10.0727 7.73135C10.0725 7.99822 10.1783 8.25423 10.3669 8.44306C10.5555 8.6319 10.8113 8.73809 11.0782 8.73827C11.345 8.73846 11.601 8.63263 11.7899 8.44406L12.7089 7.52406C13.1182 7.11482 13.4429 6.62896 13.6644 6.09423C13.8859 5.5595 13.9999 4.98636 13.9999 4.40756C13.9999 3.82876 13.8859 3.25563 13.6644 2.72089C13.4429 2.18616 13.1182 1.7003 12.7089 1.29106Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default LinkSVG;
